import { createContext, use } from 'react';

/**
 * Who owns the copy-to-clipboard affordance for a rendered value.
 *
 * - `'value'` (default): the value renders its own — the hover pill in
 *   CopyOnHoverValue. Right for tables, lists and inline prose, where the
 *   value is the only thing under the pointer.
 * - `'host'`: the surface showing the value (a record's overview row) has
 *   its own copy control and the value renders plain. Two hover surfaces
 *   nested in one row — the row's tint plus the pill's — read as a control
 *   inside a control, and put a second copy button beside the first.
 *
 * A context rather than a prop: the value sits several generic renderers
 * below the host (ExpandablePropertyValue → ExpandableMultiValueLabel →
 * PropertyValueLabel → EmailValueLabel), none of which have any business
 * knowing about copy.
 */
export type CopyAffordance = 'value' | 'host';

export const CopyAffordanceContext = createContext<CopyAffordance>('value');

export function useCopyAffordance(): CopyAffordance {
  return use(CopyAffordanceContext);
}
